import { h, Fragment } from "preact";
import ProductOptionImagePill from "./product-option-image-pill";
import ProductOptionInlineHeader from "./product-option-inline-header";
import ProductOptionSizeNote from "./product-option-size-note";

export default function ProductOptionImagePillsInline({
  optionValues,
  optionName,
  updateOptionValue,
  selectedOptionValue,
  disabledOptionValues = [],
  last,
  sizeNote,
}) {
  return (
    <div
      className={`product-options__option-inline ${last ? "product-options__option-inline--last" : ""} product-options__image-pills-inline`}
    >
      <ProductOptionInlineHeader
        optionName={optionName}
        selectedOptionValue={selectedOptionValue}
      />
      <fieldset className="product-options__image-pill-list">
        <legend className="visually-hidden">{optionName}</legend>
        {optionValues.map((optionValue) => (
          <ProductOptionImagePill
            key={optionValue.name}
            optionValue={optionValue}
            optionName={optionName}
            disabled={disabledOptionValues.includes(optionValue.name)}
            updateOptionValue={updateOptionValue}
            selected={optionValue.name === selectedOptionValue}
          />
        ))}
      </fieldset>
      <ProductOptionSizeNote sizeNote={sizeNote} />
    </div>
  );
}
